import { render, staticRenderFns } from "./ApeironPermissionGroupsUpdate.vue?vue&type=template&id=56a9ced8"
import script from "./ApeironPermissionGroupsUpdate.vue?vue&type=script&lang=js"
export * from "./ApeironPermissionGroupsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports